import React from "react";
import styled from "styled-components";
import ReactModal from "react-modal";

import { Icon } from "./Icon";

import closeIcon from "../images/icons/close-icon.svg";

ReactModal.setAppElement("#___gatsby");

const CloseButton = styled.a`
  opacity: 0.6;
  position: absolute;
  top: 30px;
  right: 30px;
  transition: opacity 0.5s;
  cursor: pointer;
  z-index: 1;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
  }
`;

const variants = {
  fullscreen: {
    content: {
      backgroundColor: "#000000",
      borderRadius: "0px",
      border: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      top: "0px",
      left: "0px",
      right: "0px",
      bottom: "0px"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 10000000 - 1 // -1 from partially popup
    }
  },
  popup: {
    content: {
      margin: "6%",
      borderRadius: "8px",
      backgroundColor: "#0C0F14",
      boxShadow: "0 0 100px 10px rgba(0, 0, 0, 0.9)",
      border: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      maxWidth: 900,
      position: "relative",
      inset: 0
    },
    overlay: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 10000000 - 1 // -1 from partially popup
    }
  }
};

const CloseIcon = styled(Icon)`
  width: 40px;
  height: 40px;
`;

export function Modal({ variant = "fullscreen", ...props }) {
  const variantStyle = !!variant
    ? variants?.[variant] ?? variants.fullscreen
    : variants.fullscreen;

  return (
    <ReactModal {...props} style={variantStyle}>
      <CloseButton onClick={props.onRequestClose}>
        <CloseIcon src={closeIcon} />
      </CloseButton>
      {props.children}
    </ReactModal>
  );
}
